import appSettings from "@/_mixins/app-settings-mixin"
//ability to set the notification's position
//how do we handle quick succession of notifications (low priority)
//errors should not be dismissable
//polish the styles a tiny bit.
//consolidate the delay and timeout properties.

export default {
  watch : {},
  mixins : [appSettings],
  data: () => ({}),
  computed : {
  },
  methods : {
    addNotification(notificationConfig){
      this.globalNotification = [];
      var defaultNotification = {
        icon: null,
        type: "black", 
        message: null,
        description: null,
        dismissable: false,
        delay: 5000,
        snackbar: true,
        progressValue: true,
        top: false,
        bottom: false,
        left: false,
        right: false,
        centered: false,
      };

      let obj = null;

      switch(typeof(notificationConfig))
      {
        case "string":
          obj = Object.assign({}, defaultNotification, { message : notificationConfig});
          break;
        case "object":
          switch(notificationConfig.type.toLowerCase())
          {
            case "info":
              defaultNotification.icon = "mdi-information";
              defaultNotification.dismissable = true;
            break;
            case "warning":
              defaultNotification.icon = "mdi-alert";
              defaultNotification.dismissable = true;
            break;
            case "success":
              defaultNotification.icon = "mdi-check-circle";
              defaultNotification.dismissable = true;
            break;
            case "error":
              defaultNotification.icon = "mdi-close-circle";
              defaultNotification.dismissable = false;
            break;
            default:
              defaultNotification.icon = "mdi-image";
              defaultNotification.dismissable = true;
                
            //set defaults for each type... ie warning and error etc.
          }
          obj = Object.assign({}, defaultNotification, notificationConfig);
          break;
        default: 
          obj = Object.assign({}, defaultNotification, { message : notificationConfig.toString()});
      }
      this.globalNotification.push(obj);
    },
  }
};
